const ADD_AFFILIATE_STARTED = 'ADD_AFFILIATE_STARTED';
const ADD_AFFILIATE_SUCCESS = 'ADD_AFFILIATE_SUCCESS';
const ADD_AFFILIATE_FAIL = 'ADD_AFFILIATE_FAIL';
const ADD_AFFILIATE_RESET_VALUES = 'ADD_AFFILIATE_RESET_VALUES';
const GET_CAMPAIGN_DD_STARTED = 'GET_CAMPAIGN_DD_STARTED';
const GET_CAMPAIGN_DD_STARTED_SUCCESS = 'GET_CAMPAIGN_DD_STARTED_SUCCESS';
const GET_CAMPAIGN_DD_STARTED_FAIL = 'GET_CAMPAIGN_DD_STARTED_FAIL';

const getCampaignDropdown = (companyId, history) => {
	return {
		type: GET_CAMPAIGN_DD_STARTED,
		companyId,
		history,
	};
};
const getCampaignDropdownSuccess = (response = []) => {
	return {
		type: GET_CAMPAIGN_DD_STARTED_SUCCESS,
		response,
	};
};
const getCampaignDropdownFail = () => {
	return {
		type: GET_CAMPAIGN_DD_STARTED_FAIL,
	};
};

const addAffiliate = (affiliate) => {
	return {
		type: ADD_AFFILIATE_STARTED,
		affiliate,
	};
};
const addAffiliateResetValues = () => {
	return {
		type: ADD_AFFILIATE_RESET_VALUES,
	};
};
const addAffiliateSuccess = () => {
	return {
		type: ADD_AFFILIATE_SUCCESS,
	};
};
const addAffiliateFail = () => {
	return {
		type: ADD_AFFILIATE_FAIL,
	};
};

export default {
	types: {
		ADD_AFFILIATE_STARTED,
		ADD_AFFILIATE_SUCCESS,
		ADD_AFFILIATE_FAIL,
		ADD_AFFILIATE_RESET_VALUES,
		GET_CAMPAIGN_DD_STARTED,
		GET_CAMPAIGN_DD_STARTED_SUCCESS,
		GET_CAMPAIGN_DD_STARTED_FAIL,
	},
	creators: {
		addAffiliate,
		addAffiliateSuccess,
		addAffiliateFail,
		addAffiliateResetValues,
		getCampaignDropdown,
		getCampaignDropdownSuccess,
		getCampaignDropdownFail,
	},
};
